/**
 * GraphQL queries and mutations for Demo Admin
 */

export const CHECK_DEMO_BASELINE = `
  query GetDemoBaseline($clientId: String!) {
    getDemoBaseline(clientId: $clientId) {
      clientId
      auv
      baseSeed
      noiseSigma
      defaultSeasonalityKey
      defaultWeekdayProfileKey
      createdAt
    }
  }
`;

export const GET_DEMO_BASELINE = `
  query GetDemoBaseline($clientId: String!) {
    getDemoBaseline(clientId: $clientId) {
      clientId
      auv
      avgCheck
      laborPct
      fohWage
      bohWage
      fohBohSplit
      noiseSigma
      baseSeed
      defaultSeasonalityKey
      defaultWeekdayProfileKey
      createdAt
      updatedAt
    }
  }
`;

export const GET_DEMO_SEASONALITY = `
  query GetDemoSeasonality($seasonalityKey: String!) {
    getDemoSeasonality(seasonalityKey: $seasonalityKey) {
      seasonalityKey
      monthly
      description
      createdAt
      updatedAt
    }
  }
`;

export const GET_DEMO_WEEKDAY_PROFILE = `
  query GetDemoWeekdayProfile($profileKey: String!) {
    getDemoWeekdayProfile(profileKey: $profileKey) {
      profileKey
      weekday
      description
      createdAt
      updatedAt
    }
  }
`;

export const LIST_DEMO_UNIT_CONFIGS = `
  query ListDemoUnitConfigs($clientId: String!, $limit: Int, $nextToken: String) {
    listDemoUnitConfigs(filter: { clientId: { eq: $clientId } }, limit: $limit, nextToken: $nextToken) {
      items {
        clientId
        entityId
        orgLevel
        salesMult
        avgCheckMult
        laborPctDelta
        wageMult
        seasonalityKey
        weekdayProfileKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const SEED_DEMO_CONFIG = `
  mutation SeedDemoConfig($clientId: String!) {
    seedDemoConfig(clientId: $clientId)
  }
`;

export const START_DEMO_RUN = `
  mutation StartDemoRun($input: DemoRunInput!) {
    startDemoRun(input: $input) {
      runId
      clientId
      operation
      status
      startDate
      endDate
      seasonalityKey
      weekdayProfileKey
      baseSeed
      noiseSigma
      startedAt
      lastLogLine
    }
  }
`;

export const PURGE_DEMO_DATA = `
  mutation PurgeDemoData($scope: DemoScopeInput!) {
    purgeDemoData(scope: $scope) {
      atomic
    }
  }
`;

export const GET_DEMO_RUN = `
  query GetDemoRun($clientId: String!, $runId: ID!) {
    getDemoRun(clientId: $clientId, runId: $runId) {
      runId
      clientId
      operation
      status
      startDate
      endDate
      baseSeed
      startedAt
      endedAt
      writtenAtomic
      deletedAtomic
      lastLogLine
      errorMessage
    }
  }
`;

export const LIST_DEMO_RUNS = `
  query ListDemoRuns($clientId: String!, $limit: Int) {
    listDemoRuns(clientId: $clientId, limit: $limit, sortDirection: DESC) {
      items {
        runId
        clientId
        operation
        scopeType
        status
        startDate
        endDate
        startedAt
        endedAt
        writtenAtomic
        deletedAtomic
        lastLogLine
        errorMessage
      }
    }
  }
`;

export const LIST_LOCATIONS_BY_CLIENT = `
  query ListLocationsByClient($clientId: String!, $limit: Int, $nextToken: String) {
    locationByClientId(clientId: $clientId, limit: $limit, nextToken: $nextToken) {
      items {
        id
        locationName
        locationNumber
        closeDate
      }
      nextToken
    }
  }
`;

export const LIST_DEMO_ATOMIC_SHIFT_DAILIES = `
  query ListDemoAtomicShiftDailies(
    $filter: ModelDemoAtomicShiftDailyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDemoAtomicShiftDailies(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        clientId
        locationId
        date
        shift
        netSales
        checkCount
        fohDollars
        bohDollars
        fohHours
        bohHours
        splh
        laborPct
        id
      }
      nextToken
    }
  }
`;

export const GET_DEMO_DATA_DATE_BOUNDS = `
  query GetDemoDataDateBounds($clientId: String!) {
    earliest: demoAtomicByClientDate(
      clientId: $clientId
      sortDirection: ASC
      limit: 1
    ) {
      items {
        date
      }
    }
    latest: demoAtomicByClientDate(
      clientId: $clientId
      sortDirection: DESC
      limit: 1
    ) {
      items {
        date
      }
    }
  }
`;
